import { render, staticRenderFns } from "./Crear.vue?vue&type=template&id=13ec59e8"
import script from "./Crear.vue?vue&type=script&setup=true&lang=js"
export * from "./Crear.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports